
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[adSlug]",
      function () {
        return require("private-next-pages/events/[adSlug].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/[adSlug]"])
      });
    }
  